// Favorite script
const customerId = window.KROWN.settings.favSet.cid;
const pageType = window.KROWN.settings.favSet.pageType;
const isProductPage = pageType === 'product';
let favoritedVariantIDinDb = null;

const pdpOriginalPriceSelector = '[data-js-product-price-original]';
const pdpCurrentVariantSelector = '[data-current-value]';
const karacaCorparateNumber = 3;
const customerEmail = window.KROWN.settings.favSet.t;

const BASE_URL = 'https://shopify-api.karaca.nl';

// Common headers object for API calls
const FAV_HEADERS = {
    'Accept-Language': `${window.KROWN.settings.favSet.l}-${window.KROWN.settings.favSet.l.toUpperCase()}`,
    'X-Region': window.KROWN.settings.favSet.c,
};

const BTPRO_FAVORITE_API = {
    GET_TOKEN: BASE_URL + '/api/v1/customer/get-token',
    GET_FAVS: BASE_URL + '/api/v1/customer-favorites',
    ADD_FAV: BASE_URL + '/api/v1/customer-favorites',
    REMOVE_FAV: BASE_URL + '/api/v1/customer-favorites/remove',
};

let authTokenFav = null;
async function getAuthToken() {
    if (authTokenFav) {
        return authTokenFav;
    }
    if (!customerId || !customerEmail) {
        console.error("Token almak için customerId veya customerEmail bilgisi eksik.");
        return null;
    }
    const reqDatas = {
        email: customerEmail,
        customerId: customerId
    };
    try {
        const tokenRes = await fetch(BTPRO_FAVORITE_API.GET_TOKEN, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqDatas)
        });
        const tokenResponseJson = await tokenRes.json();
        if (tokenResponseJson.succeeded && tokenResponseJson.data && tokenResponseJson.data.token) {
            authTokenFav = tokenResponseJson.data.token;
            return authTokenFav;
        } else {
            console.error("Token alma başarısız:", tokenResponseJson.messages || "Bilinmeyen hata");
            return null;
        }
    } catch (e) {
        console.error("Token alırken hata oluştu:", e);
        return null;
    }
}

function isLoggedIn() {
    return !!customerId;
}

async function setUserFavorite(data, svgIcon, isRemove = false, productData = null) {
    svgIcon.parentNode.classList.add('svg-loading');
    const token = await getAuthToken();
    if (!token) {
        console.error("Yetkilendirme token'ı bulunamadı, işlem iptal edildi.");
        svgIcon.parentNode.classList.remove('svg-loading');
        return;
    }
    let url = isRemove ? BTPRO_FAVORITE_API.REMOVE_FAV : BTPRO_FAVORITE_API.ADD_FAV;
    let bodyData = {};
    if (isRemove) {
        bodyData = {
            favoriteProducts: [{
                ShopifyProductId: 'gid://shopify/Product/' + data.favoriteProduct.ProductTargetUniqueId,
                ShopifyProductVariantId: 'gid://shopify/ProductVariant/' + data.favoriteProduct.ProductVariantTargetUniqueId
            }]
        };
    } else {
        bodyData = {
            favoriteProducts: [{
                shopifyProductId: 'gid://shopify/Product/' + data.favoriteProduct.ProductTargetUniqueId,
                shopifyProductVariantId: 'gid://shopify/ProductVariant/' + data.favoriteProduct.ProductVariantTargetUniqueId,
                priceWhenFavorited: data.favoriteProduct.oldPrice / 100,
            }]
        };
    }
    try {
        const res = await fetch(url, {
            method: "POST",
            headers: {
                ...FAV_HEADERS,
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(bodyData)
        });
        const fetchResponse = await res.json();
        if (!fetchResponse.succeeded) {
            console.error("API işlemi başarısız oldu: ", fetchResponse.messages);
        } else {
            // DataLayer push işlemi - sadece favorilere ekleme işleminde
            if (!isRemove && productData && fetchResponse.succeeded) {
                const collections = productData.collections ? productData.collections.split(', ') : ['No Collections'];
                
                const dataLayerPush = {
                    event: 'add_to_wishlist',
                    ecommerce: {
                        wishlist_id: "", 
                        wishlist_type: "Favorites",
                        action_area: "PDP",
                        items: [{
                            item_name: productData.title,
                            item_originalPrice: data.favoriteProduct.oldPrice / 100,
                            item_id: data.favoriteProduct.ProductTargetUniqueId.toString(),
                            item_mpn: data.favoriteProduct.ProductTargetUniqueId.toString(),
                            price: data.favoriteProduct.oldPrice / 100,
                            quantity: "1",
                            item_barcode: data.favoriteProduct.ProductTargetUniqueId, 
                            item_brand: "",
                            item_category: collections[0] || "",
                            item_category2: collections[1] || "",
                            item_category3: collections[2] || "",
                            item_category4: collections[3] || "",
                            item_category5: collections[4] || "",
                            item_variant: data.favoriteProduct.ProductVariantTargetUniqueId.toString(), 
                        }]
                    }
                };
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(dataLayerPush);
            }
        }
    } catch (e) {
        console.warn("setUserFavorite ", e);
    } finally {
        svgIcon.parentNode.classList.remove('svg-loading');
    }
}

function handleLocalStorage(key, data) {
    if (customerId) return;
    const favorites = localStorage.getItem(key);
    let favoritesArray = favorites ? JSON.parse(favorites) : [];
    const dataKey = data.favoriteProduct.ProductTargetUniqueId;
    let hasData = false;
    for (let i = 0; i < favoritesArray.length; i++) {
        if (favoritesArray[i].favoriteProduct.ProductTargetUniqueId == dataKey) {
            favoritesArray.splice(i, 1);
            hasData = true;
            break;
        }
    }
    if (!hasData) {
        favoritesArray.push(data);
    }
    localStorage.setItem(key, JSON.stringify(favoritesArray));
}

function handleSessionStorage(key, data, isRemove = false) {
    if (!customerId) return;
    const favorites = sessionStorage.getItem(key);
    let favoritesArray = favorites ? JSON.parse(favorites) : [];
    const dataKey = data.favoriteProduct.ProductTargetUniqueId;
    
    if (isRemove) {
        favoritesArray = favoritesArray.filter(item => {
            const itemId = extractProductIdFromGid(item.shopifyProductId);
            return itemId != dataKey;
        });
    } else {
        let hasData = false;
        for (let i = 0; i < favoritesArray.length; i++) {
            const itemId = extractProductIdFromGid(favoritesArray[i].shopifyProductId);
            if (itemId == dataKey) {
                favoritesArray.splice(i, 1);
                hasData = true;
                break;
            }
        }
        if (!hasData) {
            favoritesArray.push({
                shopifyProductId: 'gid://shopify/Product/' + data.favoriteProduct.ProductTargetUniqueId,
                shopifyProductVariantId: 'gid://shopify/ProductVariant/' + data.favoriteProduct.ProductVariantTargetUniqueId,
                title: data.favoriteProduct.Data ? JSON.parse(data.favoriteProduct.Data).title : '',
                handle: data.favoriteProduct.Data ? JSON.parse(data.favoriteProduct.Data).handle : '',
                images: data.favoriteProduct.Data ? [JSON.parse(data.favoriteProduct.Data).img] : [],
                price: data.favoriteProduct.oldPrice / 100,
                priceWhenFavorited: data.favoriteProduct.oldPrice / 100,
            });
        }
    }
    sessionStorage.setItem(key, JSON.stringify(favoritesArray));
}

// Helper function to extract product ID from GID
function extractProductIdFromGid(gid) {
    if (typeof gid === 'string' && gid.includes('gid://shopify/Product/')) {
        return gid.split('/').pop();
    }
    return gid;
}

// Helper function to extract variant ID from GID
function extractVariantIdFromGid(gid) {
    if (typeof gid === 'string' && gid.includes('gid://shopify/ProductVariant/')) {
        return gid.split('/').pop();
    }
    return gid;
}

function handleClickFavorite(e) {
    e.preventDefault();
    const isLogin = isLoggedIn();
    if (!isLogin) {
        window.location.assign('/account/login?return_url=%2Faccount%3Fstate%3Dmy-favorites');
        return;
    }
    if (pageType === 'cart') {
        if (e.target.classList.contains('favorited-item')) return;
        e.currentTarget = e.detail.customCurrentTarget;
    }
    const productData = {
        title: e.currentTarget.dataset.favtitle,
        handle: e.currentTarget.dataset.favhandle,
        img: e.currentTarget.dataset.favimg,
        price: e.currentTarget.dataset.favprice,
        cprice: e.currentTarget.dataset.favcompareprice,
        vname: e.currentTarget.dataset.favvariantname,
        collections: e.currentTarget.dataset.productcollections
    };
    const data = {
        favoriteProduct: {
            ProductTargetUniqueId: e.currentTarget.dataset.productfavid,
            ProductVariantTargetUniqueId: e.currentTarget.dataset.variantfavid,
            CustomerTargetUniqueId: customerId,
            corporateCountry: karacaCorparateNumber,
            oldPrice: e.currentTarget.dataset.favprice,
            Data: JSON.stringify(productData)
        }
    };
    const isFavorited = e.currentTarget.classList.contains('favorited-item');
    e.currentTarget.classList.toggle('favorited-item');
    e.currentTarget.classList.toggle('!stroke-kred');
    if (!customerId) {
        handleLocalStorage('favoriteItems', data);
        return;
    }
    if (isFavorited) {
        setUserFavorite(data, e.currentTarget.parentNode, true);
        handleSessionStorage('favoriteItems', data, true);
    } else {
        setUserFavorite(data, e.currentTarget.parentNode, false, productData);
        handleSessionStorage('favoriteItems', data, false);
    }
}

function getVariantParams() {
    const params = new URLSearchParams(window.location.search);
    return +params.get('variant') || +document.querySelector('[data-current-variant]')?.getAttribute('data-current-variant');
}

function handleClickPDPFavorite(e) {
    e.preventDefault();
    const isLogin = isLoggedIn();
    if (!isLogin) {
        window.location.assign('/account/login?return_url=%2Faccount%3Fstate%3Dmy-favorites');
        return;
    }
    const isFavorited = favoritedVariantIDinDb !== null;
    const productData = {
        title: e.currentTarget.dataset.favtitle,
        handle: e.currentTarget.dataset.favhandle,
        img: e.currentTarget.dataset.favimg,
        price: e.currentTarget.dataset.favprice,
        cprice: e.currentTarget.dataset.favcompareprice,
        vname: e.currentTarget.dataset.favvariantname,
        collections: e.currentTarget.dataset.productcollections
    };
    const data = {
        favoriteProduct: {
            ProductTargetUniqueId: e.currentTarget.dataset.productfavid,
            ProductVariantTargetUniqueId: e.currentTarget.dataset.variantfavid,
            CustomerTargetUniqueId: customerId,
            oldPrice: e.currentTarget.dataset.favprice,
            corporateCountry: karacaCorparateNumber,
            Data: JSON.stringify(productData)
        }
    };
    e.currentTarget.classList.toggle('favorited-item');
    e.currentTarget.classList.toggle('!stroke-kred');
    if (isFavorited) {
        handleDeleteFavorite(data, e.currentTarget);
    } else {
        handleAddFavorite(data, productData, e.currentTarget);
    }
}

function handleAddFavorite(data, productData, svgIcon) {
    const currentVariant = getVariantParams();
    const currentPriceElement = document.querySelector(pdpOriginalPriceSelector);
    const currentPrice = currentPriceElement ? Number(currentPriceElement.innerText.replace(/[^\d.,]/g, "").replace(",", ".")) : 0;

    let variantStr = "";
    const currentVariantNames = document.querySelectorAll(pdpCurrentVariantSelector);
    currentVariantNames.forEach((item, i) => {
        variantStr += item.innerText;
        i < currentVariantNames.length - 1 ? variantStr += ' / ' : null;
    });
    productData.price = currentPrice;
    productData.vname = variantStr;
    data.favoriteProduct.ProductVariantTargetUniqueId = currentVariant;
    data.favoriteProduct.oldPrice = currentPrice * 100;
    data.favoriteProduct.Data = JSON.stringify(productData);
    favoritedVariantIDinDb = currentVariant;
    if (!customerId) {
        const favorites = localStorage.getItem('favoriteItems');
        const arr = favorites ? JSON.parse(favorites) : [];
        arr.push(data);
        localStorage.setItem('favoriteItems', JSON.stringify(arr));
        return;
    }
    handleSessionStorage('favoriteItems', data, false);
    setUserFavorite(data, svgIcon, false, productData);
}

function handleDeleteFavorite(data, svgIcon) {
    data.favoriteProduct.ProductVariantTargetUniqueId = favoritedVariantIDinDb;
    favoritedVariantIDinDb = null;
    if (!customerId) {
        const favorites = localStorage.getItem('favoriteItems');
        let arr = favorites ? JSON.parse(favorites) : [];
        arr = arr.filter(item => item.favoriteProduct.ProductTargetUniqueId != data.favoriteProduct.ProductTargetUniqueId);
        localStorage.setItem('favoriteItems', JSON.stringify(arr));
        return;
    }
    handleSessionStorage('favoriteItems', data, true);
    setUserFavorite(data, svgIcon, true);
}

async function setLocalStorageToDb(response, localfavs) {
    const token = await getAuthToken();
    if (!token) {
        console.error("Yetkilendirme token'ı bulunamadı, localStorage senkronizasyonu iptal edildi.");
        return;
    }
    const parsed = JSON.parse(localfavs);
    const dbIdArray = response.map(item => extractProductIdFromGid(item.shopifyProductId));
    for (let i = 0; i < parsed.length; i++) {
        if (!dbIdArray.includes(parsed[i].favoriteProduct.ProductTargetUniqueId)) {
            const dataToSend = {
                favoriteProducts: [{
                    shopifyProductId: 'gid://shopify/Product/' + parsed[i].favoriteProduct.ProductTargetUniqueId,
                    shopifyProductVariantId: 'gid://shopify/ProductVariant/' + parsed[i].favoriteProduct.ProductVariantTargetUniqueId,
                    priceWhenFavorited: parsed[i].favoriteProduct.oldPrice / 100,
                }]
            };
            await fetch(BTPRO_FAVORITE_API.ADD_FAV, {
                method: "POST",
                headers: {
                    ...FAV_HEADERS,
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(dataToSend)
            });
        }
    }
    localStorage.removeItem('favoriteItems');
    getUserFavorites();
}

function handleFillFavoriteIcons(data, allFavoriteIcons, isSession = false) {
    if (!data.length) {
        allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'));
        return;
    }
    let userFavoriteMap;
    if (!customerId) {
        data = data.map(item => item.favoriteProduct);
        userFavoriteMap = new Map(data.map(item => [item.ProductTargetUniqueId, item.ProductVariantTargetUniqueId]));
    } else {
        // API'dan gelen veriler için - her zaman GID formatında
        userFavoriteMap = new Map(data.map(item => [
            extractProductIdFromGid(item.shopifyProductId),
            extractVariantIdFromGid(item.shopifyProductVariantId)
        ]));
    }
    
    requestAnimationFrame(() => {
        allFavoriteIcons.forEach(icon => {
            const id = icon.dataset.productfavid;
            const variantId = icon.dataset.variantfavid;

            let isFavorited = false;
            for (const [favProdId, favVarId] of userFavoriteMap.entries()) {
                if (String(favProdId) === String(id) && String(favVarId) === String(variantId)) {
                    isFavorited = true;
                    break;
                }
            }
            
            if (isFavorited) {
                icon.classList.add('favorited-item');
                icon.classList.add('!stroke-kred');
            } else {
                icon.classList.remove('favorited-item');
                icon.classList.remove('!stroke-kred');
            }
            icon.parentNode.classList.remove('svg-loading');
        });
        
        if (isProductPage) {
            const currentVariantFromUrl = getVariantParams();
            const currentProductId = document.querySelector('[data-productfavid]')?.dataset.productfavid;

            const sessionFavorites = sessionStorage.getItem('favoriteItems');
            if (sessionFavorites) {
                const parsedSessionFavorites = JSON.parse(sessionFavorites);
                for (const item of parsedSessionFavorites) {
                    const favProdId = extractProductIdFromGid(item.shopifyProductId);
                    const favVarId = extractVariantIdFromGid(item.shopifyProductVariantId);

                    if (String(favProdId) === String(currentProductId) && String(currentVariantFromUrl) === String(favVarId)) {
                        favoritedVariantIDinDb = favVarId;
                        const pdpFavIcon = document.querySelector('[data-favorite-item][data-productselector]');
                        if (pdpFavIcon) {
                            pdpFavIcon.classList.add('favorited-item');
                            pdpFavIcon.classList.add('!stroke-kred');
                        }
                        break;
                    }
                }
            }
        }
    });
}

async function getUserFavorites() {
    const allFavoriteIcons = document.querySelectorAll('[data-favorite-item]');
    if (!allFavoriteIcons || allFavoriteIcons.length === 0) return;

    allFavoriteIcons.forEach(icon => icon.parentNode.classList.add('svg-loading'));

    const localFavorites = localStorage.getItem('favoriteItems');
    if (!customerId && localFavorites) {
        handleFillFavoriteIcons(JSON.parse(localFavorites), allFavoriteIcons);
        return;
    }
    if (!customerId && !localFavorites) {
        allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'));
        return;
    }

    const sessionFavorites = sessionStorage.getItem('favoriteItems');
    if (sessionFavorites) {
        const parsedSessionFavorites = JSON.parse(sessionFavorites);
        if (parsedSessionFavorites.length) {
            handleFillFavoriteIcons(parsedSessionFavorites, allFavoriteIcons, true);
            return;
        }
    }

    const token = await getAuthToken();
    if (!token) {
        console.error("Yetkilendirme token'ı bulunamadı, favoriler getirilemedi.");
        allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'));
        return;
    }

    try {
        const res = await fetch(BTPRO_FAVORITE_API.GET_FAVS, {
            method: "GET",
            headers: {
                ...FAV_HEADERS,
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });

        const fetchResponse = await res.json();
        if (!fetchResponse.succeeded) {
            console.error("Favoriler getirilirken API hatası:", fetchResponse.messages);
            allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'));
            return;
        }
        const responseData = fetchResponse.data;

        if (customerId && localFavorites && responseData) {
            setLocalStorageToDb(responseData, localFavorites);
            return;
        }
        
        sessionStorage.setItem('favoriteItems', JSON.stringify(responseData));
        handleFillFavoriteIcons(responseData, allFavoriteIcons);
    } catch (e) {
        console.error("getUserFavorites", e);
        allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'));
    }
}

window.addEventListener("DOMContentLoaded", getUserFavorites);